// Public cart API for scripts outside the theme bundle. Bloomreach's
// recommendation widgets render their own add-to-bag buttons, so they need the
// same path the theme's quick add uses: add, refresh the minicart (which fires
// minicart:rendered), optionally open the drawer. On the cart page the cart
// section re-renders too (which fires cart:rendered).
//
//   window.theme.cart.add({ variantId, quantity = 1, openCart = false })
//     -> Promise<cart JSON>, resolved after the cart UI has refreshed;
//        rejects when Shopify refuses the add (e.g. sold out) or the request fails
//   window.theme.cart.get() -> Promise<cart JSON>

import addToCart from '../lib/addToCart';
import getCart from '../lib/getCart';
import renderMinicart from '../lib/renderMinicart';
import { EVENTS } from '../utils/constants';

const add = async ({ variantId, quantity = 1, openCart = false } = {}) => {
  const id = Number(variantId);
  if (!id) throw new Error('theme.cart.add: variantId is required');

  // addToCart swallows network errors (undefined) and resolves Shopify error
  // responses like 422 as { status, description }
  const result = await addToCart(id, Number(quantity) || 1);
  if (!result || result.status) throw new Error(result?.description || 'Add to cart failed');

  await renderMinicart();
  if (document.querySelector('[data-cart-line-items]')) {
    document.dispatchEvent(new CustomEvent(EVENTS.CART_CHANGED));
  }
  if (openCart) window.theme.minicart?.open();
  return getCart();
};

const initCartApi = () => {
  if (!window.theme || window.theme.cart) return;
  window.theme.cart = { add, get: getCart };
};

export default initCartApi;
